/**
 * Runtime platform detection — the ONE place the app is allowed to branch on
 * "native vs web" (techsheet rule 6: differences at runtime, never a second
 * codebase).
 */
import { Capacitor } from '@capacitor/core'

export const isNative = (): boolean => Capacitor.isNativePlatform()
export const isIOS = (): boolean => Capacitor.getPlatform() === 'ios'
export const isAndroid = (): boolean => Capacitor.getPlatform() === 'android'
export const isWeb = (): boolean => Capacitor.getPlatform() === 'web'
export const platform = (): string => Capacitor.getPlatform()
